// @flow
import { pictureInQuestionCount, questionsCount } from 'constants/params'

const picturesCount = pictureInQuestionCount * questionsCount

const url = `https://10years.lifehacker.ru/picturer/api/?pictureCount=${picturesCount}`

function generateId() {
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export default async function () {
  const questions: Array<Question> = []
  const pictures: Array<Picture> = await fetch(url).then(res => res.json())

  for (let i = 0; i < pictures.length; i+=pictureInQuestionCount) {
    const picturesForQuestion = pictures.slice(i, i+pictureInQuestionCount)

    questions.push({
      id: generateId(),
      isAnswerCorrect: false,
      pictures: picturesForQuestion
    })
  }

  return questions
}




// WEBPACK FOOTER //
// ./src/lib/getQuestions.js